"use client";

import Image from "next/image";
import Link from "next/link";

const styles = `
  @keyframes heartbeat {
    0%, 100% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.2);
    }
    50% {
      transform: scale(1);
    }
  }

  @keyframes pulse-glow {
    0%, 100% {
      filter: drop-shadow(0 0 0px rgba(37, 99, 235, 0.5));
    }
    50% {
      filter: drop-shadow(0 0 8px rgba(37, 99, 235, 0.8));
    }
  }

  .animated-heart {
    animation: heartbeat 1.5s ease-in-out infinite, pulse-glow 1.5s ease-in-out infinite;
    display: inline-block;
  }
`;

export function Footer() {
  const handleRequestDemo = () => {
    window.open("https://form.typeform.com/to/w6upDqu2", "_blank");
  };

  return (
    <>
      <style>{styles}</style>
      <footer className="bg-background px-4 sm:px-7 lg:px-14 xl:px-28 py-12 sm:py-20 lg:py-32">
        <div className=" bg-neutral-1000/20 border border-dark-slate/60 pt-6 sm:pt-8 lg:pt-10 pb-4 sm:pb-5 px-4 sm:px-8 lg:px-12 rounded-20">
          <div className="flex flex-col lg:flex-row items-start sm:items-center justify-between gap-8 sm:gap-10 lg:gap-12 mb-12 sm:mb-16 lg:mb-22">
            <div className="flex flex-col gap-6 sm:gap-8 lg:gap-10 w-full lg:w-auto">
              <div className="relative w-28 sm:w-32 h-6 sm:h-8">
                <Image
                  src="/assets/icons/assetilo-complete-desktop.svg"
                  alt="Assetilo logo"
                  fill
                  className="object-contain"
                />
              </div>

              <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-normal text-silver-gray leading-[0.9] max-w-sm font-geist-pixel-square tracking-tight-3 ">
                Clarity for <br />
                asset-driven <br />
                organizations.
              </h2>
            </div>

            <div className="flex flex-wrap gap-3 w-full sm:w-auto sm:flex-nowrap">
              <Link
                href="/signup"
                className="bg-accent-primary hover:bg-accent-primary/80 text-white whitespace-nowrap flex-1 sm:flex-none px-5 sm:px-8 py-2.5 rounded-lg transition-colors text-sm sm:text-base font-medium text-center"
              >
                Get started for free
              </Link>
              <button
                onClick={handleRequestDemo}
                className="bg-transparent border border-dark-slate hover:border-dark-slate/20 text-gray-400 hover:text-white whitespace-nowrap flex-1 sm:flex-none px-5 sm:px-8 py-2.5 rounded-lg transition-colors text-sm sm:text-base font-medium"
              >
                Request a demo
              </button>
            </div>

            <div className="flex flex-col gap-6 sm:gap-8 lg:gap-13 w-full lg:w-auto">
              <p className="text-silver-gray text-sm sm:text-sm lg:text-lg font-medium capitalize tracking-wider text-left lg:text-right">
                Asset Intelligence for the real-world
              </p>

              <div className="text-left lg:text-right">
                <p className="text-silver-gray text-lg sm:text-2xl lg:text-3xl font-medium leading-7 sm:leading-8 lg:leading-9">
                  Know what you own<span className="text-blue-700">.</span>
                </p>
                <p className="text-silver-gray text-lg sm:text-2xl lg:text-3xl font-medium leading-7 sm:leading-8 lg:leading-9">
                  Know where it is<span className="text-brown-700">.</span>
                </p>
                <p className="text-silver-gray text-lg sm:text-2xl lg:text-3xl font-medium leading-7 sm:leading-8 lg:leading-9">
                  Know what to do next<span className="text-purple-600">.</span>
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-dark-slate pt-4 sm:pt-6 lg:pt-8">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-3 lg:gap-4 text-center sm:text-left">
              <p className="text-silver-gray text-xs sm:text-sm lg:text-base font-medium">
                © 2026 Assetilo. All rights reserved.
              </p>

              <p className="text-silver-gray text-xs sm:text-sm lg:text-base font-medium flex items-center justify-center">
                Made with{" "}
                <span className="animated-heart mx-1">
                  <svg
                    className="w-4 h-4 text-blue-700 fill-current inline-block"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                  </svg>
                </span>
                in Milton Keynes, UK.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
